import { ThemeContext } from '@/theme/ThemeProvider';
import { useContext } from 'react';
import { MobileMenuButton } from './style';

export default function MobileMenuBtn({ handleToggleMenu }: { handleToggleMenu: () => void }) {
  const {  isDarkMode, toggleTheme, } = useContext(ThemeContext);
  const theme = isDarkMode ? 'dark' : 'light';
  return (
    <MobileMenuButton onClick={handleToggleMenu}>
      <svg
        width="18"
        height="12"
        viewBox="0 0 18 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 12V10H18V12H0ZM0 7V5H18V7H0ZM0 2V0H18V2H0Z"
          fill={theme === 'light' ? '#000' : '#fff'}
        />
      </svg>
    </MobileMenuButton>
  );
}
